module.exports = __webpack_public_path__ + "media/images/coordinador-7f29b887af4a3ef3b493ca1f8d82315d.png";